import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Assets
 */
import NoNotificationsSVG from '../../assets/illustrations/no_notifications.svg';

/**
 * MUI Components
 */
import { Fade } from '@mui/material';

/**
 * Components
 */
import NotificationCard from './NotificationCard';
import EmptyState from '../../components/EmptyState';

const styles = {
    notificationList: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
};

const ListNotifications = ({ items, lastItemRef = null }) => {
    const { t } = useTranslation();
    const [localItems, setLocalItems] = useState(items);

    // Sync local items when items prop changes
    useEffect(() => {
        setLocalItems(items);
    }, [items]);

    const handleDelete = (uuid, notification) => {
        setLocalItems((prevItems) => prevItems.filter((item) => item.id !== uuid));
    };

    if (!Array.isArray(localItems) || localItems.length < 1) {
        return (
            <Fade in={true} >
                <div>
                    <EmptyState
                        message={t('No notifications found')}
                        illustration={NoNotificationsSVG}
                    />
                </div>
            </Fade>
        );
    }

    return (
        <div style={styles.notificationList}>
            {localItems.map((item, index) => {
                const isLast = index === localItems.length - 1;
                return (
                    <div key={item.id} ref={isLast ? lastItemRef : null}>
                        <NotificationCard notification={item} onDelete={handleDelete} />
                    </div>
                );
            })}
        </div>
    );
};

export default ListNotifications;